// extracted by mini-css-extract-plugin
export default {"ui":"ui_ui__siD+U","upperBlock":"ui_upperBlock__hEF9e","w-100-dynamic":"ui_w-100-dynamic__igI7S","upperBar":"ui_upperBar__cmZV5","loadingContainer":"ui_loadingContainer__ZwaZf"};